export default "/images/LarsTorp.jpg?792ed1e8f6eab510d4e19519bc5f0d02";